// extracted by mini-css-extract-plugin
export default {"payment":"Lu","title_row":"Mu","border_bottom":"Nu","promo_wrapper":"Ou","payment_wrapper":"Pu","label":"Qu","card_row":"Ru","cardcontain":"Su","card_input":"Tu","card_error":"Uu","card_label":"Vu","lock":"Wu","same_address":"Xu","place_order_button":"Yu","buttonwrap":"Zu","hide_form":"av","paypal_buttons":"bv","review_button":"cv","alt_payment":"ev"};
    if(module.hot) {
      // 1738064238252
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  